import React, { useEffect, useState } from "react";
import helper from "../../../../../../utils/helper";

const TimeRangeCard = ({ value, onChange }) => {
    const [localSchedule, setLocalSchedule] = useState({
        start: "00:00",
        end: "23:59"
    });

    useEffect(() => {
        if (value) {
            setLocalSchedule(value);
        }
    }, [value]);

    const calculateEndTime = (start) => {
        if (!start) return "23:59";

        const [h, m] = start.split(":").map(Number);
        const date = new Date();
        date.setHours(h);
        date.setMinutes(m);

        date.setHours(date.getHours() + 24);
        date.setMinutes(date.getMinutes() - 1);

        return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    };

    const handleChangeStart = (value) => {
        const end = calculateEndTime(value);

        const updated = {
            start: value,
            end
        };

        setLocalSchedule(updated);
        onChange?.(updated);
    };

    return (
        <div className="grant-schedule__card">
            <h5 className="grant-schedule__card--time-title">
                Período de Trabalho
                <i
                    className="las la-info-circle fa-15px"
                    style={{ cursor: "pointer" }}
                    title="Regra de horário"
                    onClick={() =>
                        helper.dispatchEvent("showAviso", {
                            message:
                                `A hora final é calculada automaticamente (24h após o início).
                                Isso significa que se a hora final for menor que a hora inicial,
                                o horário de trabalho inicia em um dia e termina no dia seguinte.`
                        })
                    }
                />
            </h5>

            <div className="grant-schedule__card--time-card">
                <div className="grant-schedule__card--time-card__input">
                    <label>Início</label>
                    <input
                        type="time"
                        value={localSchedule.start}
                        onChange={(e) => handleChangeStart(e.target.value)}
                    />
                </div>

                <div className="grant-schedule__card--time-card__input">
                    <label>Fim</label>
                    <input
                        type="time"
                        value={localSchedule.end}
                        disabled
                        title="Horário calculado automaticamente (24h após o início)"
                    />
                </div>
            </div>
        </div>
    );
};

export default TimeRangeCard;